var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_423",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_423",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAACDUlEQVRoge2Xz0sUYRyHn+867o4KBh2MFjoI/cSKPERl/QWBh41O/g8G0q+FRdukSDzkQf+FblFeQuoSEXTyoiX9WIhgg7xooUEOu87bwUu8M7Pjjs5MA+9z/L7v553Pw8K7M2AwGDKN+E7HVg5SYAJUCSgCq4h6DtZ9Hp1aS7RhCF6BnfLvQJ3w2f8Fu3GB6uCv+KvtjpxnklfjAeUBjvMnX4m3Unt4BYRrrROqFFeZKHgF4HDLhOJIPFWi4SewGpL5EUeRqPgIyLPWEfU0nirR8Ao4TAK1gP0fsZsPYm3UJl6BmYF1Gp1DwBzwHWgC31A8Bvfy/3SFGgz7gPdVovxBhaamTu89d+dTkY7GCIphkH6gD1gDvqLkBZb7hIdn6mFHWqEP3W9GawV6nAo0yyjp1FaLQBFRV9iWe5RXZrG7J6j2bwUd5/dHFh93Fw/Q47wFxgG9vI4N6jZbv19za6kvaFOyAtK1AJxvM3QRy5pntFbwW01WAHUpcq7bmfRbSVhgDwg3qLz3vEhmRwBstmVEH6YhUAeu41q9uFYvkiuBfN5dVF3VJ0lfo3UcOcfMwPo/s3nKy28gtwRh3xpyVJ8k/QuMaeV3mDr7E+RmeFwO6ZNkBVzrVeCanX8ZfoDq0CfJCkyf3Axcqx7biHJklm4hX4xA2hiBtDECaWME0sYIpI0RSJvMCxgMhozzF6yLcwBDfZPMAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8fdb947764caf2eb418813c3bb8c38d9.svg";
export { ForwardRef as ReactComponent };